/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import FormInputs from "../../FormInputs";
import {useParams} from "react-router-dom";
import useData from "../../../hooks/useData";
import {getLegalFormList} from "../../../api/admin/legalFormListReq";
import useAuth from "../../../hooks/useAuth";
import {updateNetworkInfos, uploadNetworkLogo} from "../../../api/admin/networkReq";
import {
    checkRequiredFields,
    fileToBase64,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import FormButtons from "../../../components/common/FormButtons";
import Icon from "../../../components/common/Icon";

export default function FormNetworkGeneral({ setShowModal, legend, apiNetworkInfos }) {
    const { auth } = useAuth();
    const token = auth.token;
    let { id } = useParams();
    const {networkMainInfos, legalFormList, setLegalFormList} = useData();
    const [ selectedImage, setSelectedImage ] = useState();
    const [ values, setValues ] = useState();
    const IMG_FOLDER = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const logoSrc = values?.logo ? IMG_FOLDER +'media/logos/'+ values?.logo : "";

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e);
    };

    const apiLegalFormList = async () => {
        const response = await getLegalFormList(token);
        setLegalFormList(response);
    };

    const handleRemoveModal = (e) => {
        e.preventDefault();
        setShowModal(false)
    };

    useEffect(() => {
        setValues(networkMainInfos);
    }, [ networkMainInfos ]);

    const apiUploadedFile = async(fileType) => {
        let fileName = "";
        const formData = new FormData();
        formData.append('file', base64String);
        formData.append('file_type', fileType);
        if (fileType === "logo") {
            fileName = values?.logo
        }
        formData.append('file_name', fileName);
        const response = await uploadNetworkLogo(token, formData, id)
            .then((response) => {
                if (fileType === "logo") {
                    setValues({...values, logo : response?.file_name})
                } else {
                    console.log("error")
                }})
    }
    const [ base64String, setBase64String ] = useState(null);

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result)
        }
        reader.readAsDataURL(selectedFile)
        try {
            const base64StringConst = await fileToBase64(selectedFile);
            setBase64String(base64StringConst)
            setValues({...values, [e.target.name] : selectedFile.name})
        } catch (error) {
            console.error("Erreur lors de la conversion en base64 : ", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        if(base64String) {
            apiUploadedFile("logo")
        }
        let typeOfLegalForm = typeof(values?.legalForm) === "object" ? values?.legalForm?.id : values?.legalForm;
        let body = {
            networkId: id,
            name: values?.name,
            legalFormId: typeOfLegalForm || 0,
            logo: values?.logo,
            authorizationCode: values?.authorizationCode,
            registrationDate: values?.registrationDate,
            siret: values?.siret,
            tva: values?.tva,
            capital: parseInt(values?.capital),
            workforce: parseInt(values?.workforce),
        }
        await updateNetworkInfos(token, body)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false);
                    apiNetworkInfos();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    useEffect(() => {
        apiLegalFormList();
    },[ id ]);

    const inputs = [
        {
            id : 1,
            name : "name",
            type : "text",
            placeholder : "Nom du réseau",
            label : "Nom",
            pattern : patternListChoices?.name,
            required : true,
        },
        {
            id : 4,
            name : "authorizationCode",
            type : "text",
            placeholder : "Code d'habilitation",
            label : "Code d'habilitation",
            pattern: patternListChoices?.alphaNum
        },
        {
            id : 5,
            name : "registrationDate",
            type : "date",
            placeholder : "jj/mm/AAAA",
            label : "Date d'immatriculation",
        },
        {
            id : 6,
            name : "siret",
            type : "text",
            placeholder : "Siret",
            label : "Siret",
            pattern: patternListChoices?.siret
        },
        {
            id : 7,
            name : "tva",
            type : "text",
            placeholder : "TVA intracommunautaire",
            label : "TVA intracommunautaire",
            pattern: patternListChoices?.tvaIntra
        },
        {
            id : 8,
            name : "capital",
            type : "text",
            placeholder : "",
            label : "Capital",
            pattern: patternListChoices?.num
        },
        {
            id : 9,
            type : "text",
            name : "workforce",
            placeholder : "Effectif",
            label : "Effectif",
            pattern: patternListChoices?.num,
        },
    ];

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                <Icon source="fa-solid fa-user-group" span={legend} />
                <div className="form-input">
                    <label htmlFor="legalForm">Forme juridique</label>
                    <select value={values?.legalForm?.id} name="legalForm" onChange={onChange}>
                        <option value="">Choisissez une forme juridique</option>
                        {legalFormList?.map(legalForm => (
                            <option value={legalForm.id} key={legalForm.id}>{legalForm.name}</option>
                        ))}
                    </select>
                </div>
                {inputs.map(input => (
                    <FormInputs
                        type={input.type}
                        name={input.name}
                        id={input.id}
                        label={input.label}
                        placeholder={input.placeholder}
                        value={values?.[input.name]}
                        onChange={onChange}
                        required={input.required}
                        options={input.options}
                        multiple={input.multiple}
                        key={input.id + input.name}
                        pattern={input.pattern}
                        handleFileChange={handleFileChange}
                    />
                ))}
                <div className="form-input">
                    <label htmlFor="logo">Logo</label>
                    <input type="file" name="logo" onChange={handleFileChange}/>
                    <img src={selectedImage ? selectedImage : logoSrc} alt="logo" className="logo-preview"/>
                </div>
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleSubmit={handleSubmit} handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}
